import { httpClient } from '@/services/http/httpClient'

type InviteUsersParams = {
  userIds: string[]
  ideaId: string
  message: string
}

export async function inviteUsers({
  ideaId,
  message,
  userIds,
}: InviteUsersParams): Promise<void> {
  await httpClient.post('/ideas/idea-users/invite-users-to-idea', {
    receiverIds: userIds,
    ideaId,
    message,
    action: 'INVITE',
  })
}
